/*!
=========================================================
* 売掛金入金登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardTitle,
  Table,  Row,  Col, Container,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import InputText from '../FormParts/InputText'
import InputNumber from '../FormParts/InputNumber'
import InputSelect from '../FormParts/InputSelect'
import InputRadio from '../FormParts/InputRadio'
import Request from '../../common/Request';
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import CustomTd from '../ViewParts/CustomTd';
import _ from 'underscore';
import {
  new_cst_receivable_collect_type,
  cst_receivable_collect_type,
  cst_receivable_collect_bank_type,
  cst_accounts_receivable_status_action,
  cst_accounts_receivable_collection_action
} from '../../variables/codes_map';
import Definition from '../../common/Definition'
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import WithRole from '../FormParts/ButtonWithRole';
import InputDatetime from "../FormParts/InputDatetime";
import InputCheckBox from "../FormParts/InputCheckBox";
import { GetMessage, getErrorCodes } from '../../variables/message';
import AlertAndpadModal from '../ViewParts/AlertAndpadModal';

const moment = require("moment");

class Regist extends React.Component {

  constructor(props){
    super(props);
    this.state ={
        regist_modal: false,
        sub_regist_modal: false,
        quote_available_change_range_modal: false,
        error_modal: false,
        view: false,
        error:true,
        accountsReceivableDetails : [],
        data:{
          values : {
            // accounts_receivable_flag : 0,
            accounts_receivable_status: 1,
            accounts_receivable_status_flag: 0, //回収状況の表示にのみ使用。保存されない
            accounts_receivable_status_action: 1,
          },
          errors:{},
          requiredData:{},
        },
        dialogData : {
          values:{
            extention_remind_send_flag: 0,
          },
          errors:{},
          requiredData:{
            receivable_collect_date:[GetMessage(2024)],
            receivable_collect_amt:[GetMessage(2024)],
            receivable_collect_type:[GetMessage(2024)],
          }
        },
        lastUpdateData:{
          extention_remind_send_flag: 0
        },
        request_data:{},
        estimate:{},
        user_list : [],
        suspenseReceiptsAccountCollectAmt:0,
        is_changed: false,
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleClearModal = this.toggleClearModal.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.toggleQuoteAvailableChangeRangeModal = this.toggleQuoteAvailableChangeRangeModal.bind(this);
    this.summation_select_popup = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.validateDialogCallback = this.validateDialogCallback.bind(this)
    this.validateQuoteAvailableChangeDate = this.validateQuoteAvailableChangeDate.bind(this);
    this.regist = this.regist.bind(this)
    this.accounts_receivable_details = this.accounts_receivable_details.bind(this)
    this.selectedSecurityDeposit = this.selectedSecurityDeposit.bind(this);
    this.accountsReceivableEdit = this.accountsReceivableEdit.bind(this)
    this.accountsReceivableRemove = this.accountsReceivableRemove.bind(this);
    this.calcTotalAmount = this.calcTotalAmount.bind(this);
    this.toggleDefaultAccountsReceivableStatusAction = this.toggleDefaultAccountsReceivableStatusAction.bind(this);
    this.alertAndpadModal = React.createRef();
    this.alertChangeRangeAndpadModal = React.createRef();
  } 

  // 初期ロード用
  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      console.log("user res ", res)
      this.setState({
        user_list : res.Data
      });
    })

    // 売掛金
    Request.get(`/api/accountsreceivable`, { ulid : this.props.match.params.ulid, accounts_receivable_status : [0,1,2,3,4] } , res => {

      if(res.Data.length==0 || this.props.data_view_flag==2 && (res.Data[0]&&res.Data[0].user_branch_id != GsuiteAuth.get('user_branch_id'))){
        this.props.pageChangeAlert.current.inactivate();
        this.props.history.push('/forbidden')
        return;
      }

      this.setState({
        data : { 
          ...this.state.data,
          values : {
            ...res.Data[0],
            // accounts_receivable_flag : res.Data[0].accounts_receivable_status == 2 ? 1 : 0,
            accounts_receivable_status: res.Data[0].accounts_receivable_status != null &&  res.Data[0].accounts_receivable_status != "" ? res.Data[0].accounts_receivable_status: 1,
            accounts_receivable_status_action: res.Data[0].accounts_receivable_status,
          }
        }
      }, () => {this.toggleDefaultAccountsReceivableStatusAction()})


      const extention_remind_send_flag = res.Data[0].extention_remind_send_flag;
      console.log("extention_remind_send_flag", extention_remind_send_flag);
      // 売掛金入金履歴
      Request.get(`/api/accountsreceivable/detail`, { accounts_receivable_id : res.Data[0].accounts_receivable_id } , res => {

        // #1639
        const details = res.Data.map((detail)=>{
          let tmp = {...detail,extention_remind_send_flag: 0}
          // 2026/01/06 #2423
          // if(detail.receivable_collect_type == 5){
            tmp.extention_remind_send_flag = extention_remind_send_flag
          // }

          return tmp;
        });
        
        this.setState({
          accountsReceivableDetails : details,
          dialogData : {
            ...this.state.dialogData,
            values : {
              ...this.state.dialogData.values,
              extention_remind_send_flag
            }
          },
          lastUpdateData:{
            extention_remind_send_flag: extention_remind_send_flag
          }
        }, () => {this.toggleDefaultAccountsReceivableStatusAction()
          console.log(this.state.data.values);
        });
      })

      // 顧客の仮受金合計（残額）取得
      Request.get(`/api/suspensereceiptsaccount/customer`, { customer_id : res.Data[0].customer_id } , res => {
        const suspense_receipts_account_collect_amt = res.Data[0] ? res.Data[0].suspense_receipts_account_collect_amt : 0
        this.setState({
          suspenseReceiptsAccountCollectAmt : suspense_receipts_account_collect_amt
        });
      })
      // 会計テーブルから顧客の仮受金合計（残額）取得
      Request.get(`/api/accounts/search`, { estimate_ids : res.Data[0].estimate_id } , res => {
        const key = Object.keys(res.data)[0];
        const logData = res.data[key];
        // console.log(key);
        console.log(this.state);
        console.log(logData);
        let accounts_receivable_status = 0;
        let accounts_receivable_status_action = 0;
        const cancelData = logData.logs.filter((l)=> l.transaction_type == 19 || l.transaction_type == 79 ).length;
        // キャンセル: 売上 – 売上取消 = 入金 – 入金取消 = 0
        if(cancelData > 0 && logData.sales_total == 0 && logData.receipt_total == 0){
          accounts_receivable_status = 3;
          accounts_receivable_status_action = 3
          // 回収済: 売上 – 売上取消 = 入金 – 入金取消 > 0
        }else if(logData.sales_total == logData.receipt_total && logData.sales_total > 0){
          accounts_receivable_status = 2;
          accounts_receivable_status_action = 2
        // 未回収: 売上 – 売上取消 > 入金 – 入金取消 ≧ 0
        }else if(logData.sales_total > logData.receipt_total){
          accounts_receivable_status = 0;
          accounts_receivable_status_action = 0;
        }
        // 売上-売上取消=入金-入金取消=0の時、キャンセル
        const cancelFlag = logData.sales_total==0 && logData.receipt_total==0;
        // 合算表示内容を初期化
        this.setState(prevState => ({
          ...prevState,
          accountsLogs: logData,
          data: {
            ...prevState.data,  // 他のデータを保持
            values: {
              ...prevState.data.values,  // 他の値を保持
              cancel_sales: logData.cancel_sales,           //売上減額
              cancel_receipt: logData.cancel_receipt,           //入金減額
              before_receivable_collect_total_amt: logData.receipt_total, //読み込み時の入金合計:追加された項目との計算に使用。
              before_accounts_receivable_sales: logData.sales_total,    //読み込み時の入金合計:追加された項目との計算に使用。
              accounts_receivable_status: accounts_receivable_status,
              accounts_receivable_status_action: accounts_receivable_status_action,
            }
          }
        }));
      })
    })
  }

  validate(errors){
    let message = getErrorCodes(errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    // const required_collect_finish_date = 
    // ((newData.values.accounts_receivable_status == 2 || newData.values.accounts_receivable_status == 3) && !newData.values.receivable_collect_finish_date) 
    //   ? { receivable_collect_finish_date : [GetMessage(2024)] } 
    //   : { receivable_collect_finish_date : undefined }
    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values:{
          ...newData.values,
          // accounts_receivable_status_action: newData.values.accounts_receivable_status,
        },
        errors:{
          ...newData.errors,
          // ...required_collect_finish_date
        }
      }
    }, ()=>callback())
  }

  validateDialogCallback(newData, callback=()=>{}){
    console.log(newData)
    this.setState({
      dialogData:{
        ...newData,
        values:{
          ...newData.values,
        }
      },
      lastUpdateData:{
        extention_remind_send_flag: newData.values.extention_remind_send_flag
      }
    }, ()=>callback())
  }

  validateQuoteAvailableChangeDate(newData, callback=()=>{}, withRangeCheck=false) {
    let quote_available_change_range_failure = undefined;
    const {
      quote_available_start_date,
      quote_available_end_date,
      quote_available_change_start_date:org_quote_available_change_start_date,
      quote_available_change_end_date:org_quote_available_change_end_date
    } = this.state.data.values
    const {
      quote_available_change_start_date,
      quote_available_change_end_date
    } = newData.values;
    console.log(this.state.data.values,newData.values,withRangeCheck)

    if(withRangeCheck) {
      // 相関チェック
      // 契約開始日＜変更後開始日＜変更後終了日＜契約終了日
      if(
        quote_available_start_date &&
        quote_available_end_date &&
        quote_available_change_start_date &&
        quote_available_change_end_date) {
          const qas = new Date(quote_available_start_date).getTime();
          const qae = new Date(quote_available_end_date).getTime();
          const qacs = new Date(quote_available_change_start_date).getTime();
          const qace = new Date(quote_available_change_end_date).getTime();
          const orgqacs = new Date(org_quote_available_change_start_date).getTime();
          const orgqace = new Date(org_quote_available_change_end_date).getTime();
          
          console.log(qas + " < " + qacs + " < " + qace + " < " + qae)
          // 契約開始日＞変更後開始日
          let check = []
          if(qas > qacs){
            check.push(GetMessage(2611))
          }
          // 変更後終了日＞契約終了日
          if(qace > qae){
            check.push(GetMessage(2612))
          }
          // 変更後開始日＞変更後終了日
          if(qace < qacs){
            check.push(GetMessage(2613))
          }

          // 同じ場合は処理しない
          if(qas == qacs && qae == qace && orgqacs == qacs && orgqace == qace){
            check.push("")
          }

          if(check.length > 0){
            quote_available_change_range_failure = check
          }

          // if((qas < qacs) && (qacs < qace) && (qace < qae)) {
          //   quote_available_change_range_failure = undefined;
          // }
      }

    }
    if(quote_available_change_start_date == "" || quote_available_change_end_date =="" ){
      quote_available_change_range_failure = [GetMessage(2024)]
    }
    
    this.setState({
      dialogData:{
        ...newData,
        values:{
          ...newData.values,
        },
        errors:{
          quote_available_change_range_failure: quote_available_change_range_failure,
        }
      }
    }, ()=>callback())
  }

  validateMemoCallback(index, newData){
    const newDetail = {
      ...this.state.accountsReceivableDetails[index],
      ...newData.values,
      update : true
    }
    this.setState({
      accountsReceivableDetails: [
        ...this.state.accountsReceivableDetails.slice(0, index),
        newDetail,
        ...this.state.accountsReceivableDetails.slice(index + 1 , this.state.accountsReceivableDetails.length),
      ]
    });
  }

  selectedSecurityDeposit() {
    if(!this.validate(this.state.dialogData.errors)){
      return;
    }
    const { 
      receivable_collect_date,
      receivable_collect_amt,
      receivable_collect_type,
      receivable_collect_bank_type,
      receivable_collect_memo,
      extention_remind_send_flag,
    } = this.state.dialogData.values;
    const accountsHistoryIndex = this.state.accountsHistoryIndex
    const newData = {receivable_collect_date,receivable_collect_amt,receivable_collect_type,receivable_collect_bank_type,receivable_collect_memo,extention_remind_send_flag}
    // 過入金もしくは過売上減額のチェック
    const collectType = newData.receivable_collect_type;
    const isOver = () => {
      const salesTotal = this.state.data.values.accounts_receivable_sales; // 売上
      const receiptTotal = this.state.data.values.receivable_collect_total_amt; // 入金
      const value = newData.receivable_collect_amt; // 入力値
    
      // 過売上減額の判定関数
      const calculateOverSalesTotal = (sales, val) => sales - val < 0;
      // 過入金の判定関数
      const calculateOverReceiptTotal = (receipts, val, sales) => receipts + val > sales;
    
      // 編集の場合
      if (accountsHistoryIndex !== undefined && accountsHistoryIndex !== null) {
        const editData = this.state.accountsReceivableDetails[accountsHistoryIndex];
        const beforeDataValue = editData.receivable_collect_amt;
        const beforeCollectType = editData.receivable_collect_type;
        const isChangeCollectType = collectType !== beforeCollectType;
    
        // 入金種別の変更により元の値を戻す
        const undoSalesTotal = beforeCollectType === 5 ? salesTotal + beforeDataValue : salesTotal;
        const undoReceiptTotal = beforeCollectType === 5 ? receiptTotal : receiptTotal - beforeDataValue;
    
        // 新しい入金額を考慮
        const adjustedSalesTotal = isChangeCollectType ? undoSalesTotal - value : salesTotal + (beforeDataValue - value);
        const adjustedReceiptTotal = isChangeCollectType ? undoReceiptTotal + value : receiptTotal - (beforeDataValue - value);
    
        return collectType === 5
          ? calculateOverSalesTotal(adjustedSalesTotal, 0)
          : calculateOverReceiptTotal(adjustedReceiptTotal, 0, undoSalesTotal);
      }
    
      // 新規登録の場合
      return collectType === 5
        ? calculateOverSalesTotal(salesTotal, value)
        : calculateOverReceiptTotal(receiptTotal, value, salesTotal);
    };
    
    const overFlag = isOver();

    if(overFlag){
      this.props.alertModal.current.confirmCheck({
        // title: collectType == 5 ? GetMessage(2617) : GetMessage(2618),
        messageNo: collectType == 5 ? 2618 : 2619,
        closeBtn: false
      }, ()=>{
        // this.toggleSubRegistModal();
        // this.props.refreshCallback()
      })
      return
    }else{
      this.setState({
        ...this.state,
        accountsReceivableDetails : 
        accountsHistoryIndex === undefined 
        ?[...this.state.accountsReceivableDetails, newData]
        :[...this.state.accountsReceivableDetails.map((detail, index)=> {
          return accountsHistoryIndex === index ? {...detail, ...newData, update : detail.id === undefined ? undefined : true } : detail 
        })]
      }, () => {
        this.calcTotalAmount()
        this.toggleRegistModal();
      })
    }
  }

  accountsReceivableEdit(index){
    this.setState({
      accountsHistoryIndex : index,
      dialogData:{
        ...this.state.dialogData,
        values:{
          ...this.state.accountsReceivableDetails[index],
          extention_remind_send_flag: this.state.lastUpdateData.extention_remind_send_flag
        },
        errors : {},
      },
      regist_modal: !this.state.regist_modal
    }, () => {
      this.calcTotalAmount()
    });
  }

  accountsReceivableRemove(removeIndex){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      const newDetails = this.state.accountsReceivableDetails.map((item, index)=>{
        if(index === removeIndex){
          item.delete = true;
        }
        return item;
      })
      this.setState({
        accountsReceivableDetails: newDetails
      }, () => {
        this.calcTotalAmount()
      });
    })
  }

  toggleRegistModal(reset=false) {
    if (reset) {
      console.log(this.state.dialogData);
      this.setState({
        ...this.state,
        regist_modal: !this.state.regist_modal,
        accountsHistoryIndex : undefined,
        dialogData:{
          ...this.state.dialogData,
          values:{
            // 2026/01/06 #2423
            ...this.state.dialogData.values,
            id: undefined,
            receivable_collect_amt: null,
            receivable_collect_type: null,
            receivable_collect_bank_type: 0,
            receivable_collect_memo: null,
            receivable_collect_date : moment().add(-1, "days").format("YYYY-MM-DDT00:00:00"),
            extention_remind_send_flag: this.state.lastUpdateData.extention_remind_send_flag
          },
          errors:{
            // receivable_collect_date:[GetMessage(2024)],
            receivable_collect_amt:[GetMessage(2024)],
            receivable_collect_type:[GetMessage(2024)],
          }
        },
      });
    } else {
      this.setState({
        regist_modal: !this.state.regist_modal,
      })
    }
  }

  toggleSubRegistModal(){
    this.setState({
      sub_regist_modal: !this.state.sub_regist_modal
    });
  }

  toggleQuoteAvailableChangeRangeModal(){
    if(this.state.quote_available_change_range_modal) {
      this.setState({
        quote_available_change_range_modal: false
      });
    } else {
      this.setState({
        quote_available_change_range_modal: true,
        dialogData:{
          ...this.state.dialogData,
          values:{
            quote_available_change_start_date: this.state.data.values.quote_available_change_start_date ? this.state.data.values.quote_available_change_start_date : this.state.data.values.quote_available_start_date,
            quote_available_change_end_date: this.state.data.values.quote_available_change_end_date ? this.state.data.values.quote_available_change_end_date : this.state.data.values.quote_available_end_date
          },
        },
      });
    }
  }

  toggleClearModal() {
    this.setState({
      clear_modal: !this.state.clear_modal,
    })
  }

  regist() {
    // const estimateId = this.state.data?.values?.estimate_id;
    const accountsLogData = this.state.accountsLogs ? this.state.accountsLogs || {} : {};
    const params = {
      accountsReceivable : this.state.data.values,
      accountsReceivableDetails : this.state.accountsReceivableDetails.filter(item => !(item.id === undefined && item.delete === true)).map((detail)=>{
        return {
          ...detail,
          receivable_collect_user_id : GsuiteAuth.get("id"),
        }
      }),
      accountsLog: accountsLogData,
      lastUpdateData: this.state.lastUpdateData
    }

    Request.put('/api/accountsreceivable/detail/update', params, res => {
      if (res.Code == 816){
        this.props.alertModal.current.confirmCheck({
          title: res.data.message,
          messageNo: 2616,
          closeBtn: false
        }, ()=>{
          this.toggleSubRegistModal();
        }, false)
      }else{
        // #1674 ANDPAD対応
        this.props.pageChangeAlert.current.inactivate();
        this.toggleSubRegistModal();
        const cancel_sales_flag = params.accountsReceivableDetails.some(detail => detail.receivable_collect_type == 5) || params.accountsReceivable.cancel_sales > 0;
        const is_collect_cancel = params.accountsReceivableDetails.some(detail => detail.receivable_collect_type == 5);
        const {ex_andpad_use_flag, ex_andpad_access_token_key, register_type, ex_andpad_system_id,accounts_receivable_sales,invoice_natural_id,ex_andpad_quote_delete_flag, ex_andpad_estimate_delete_flag, ex_andpad_plotting_delete_flag, quote_available_change_start_date, quote_available_change_end_date, quote_available_start_date, quote_available_end_date} = params.accountsReceivable;
        const quote_available_change_flag = quote_available_change_start_date != null || quote_available_change_end_date != null ? true : false;
        const andpad_use_flag = ex_andpad_use_flag == 1 && 
                                ex_andpad_access_token_key != "" && 
                                ex_andpad_access_token_key != null &&
                                ex_andpad_system_id != "" && 
                                ex_andpad_system_id != null &&
                                parseInt(register_type) == 1 && 
                                ex_andpad_estimate_delete_flag == 0 && 
                                ex_andpad_plotting_delete_flag == 0 && 
                                (quote_available_change_flag == true && is_collect_cancel == true || cancel_sales_flag == true && accounts_receivable_sales == 0 )? true : false;

        // 全額売上減額
        console.log("andpad_use_flag", andpad_use_flag, "cancel_sales_flag", cancel_sales_flag, "quote_available_change_flag", quote_available_change_flag, "is_collect_cancel", is_collect_cancel);
        console.log(params.accountsReceivable);
        // console.log("cancel_sales_flag", cancel_sales_flag,"ex_andpad_use_flag", ex_andpad_use_flag, "ex_andpad_access_token_key", ex_andpad_access_token_key, "ex_andpad_system_id", ex_andpad_system_id, "register_type", register_type, "andpad_use_flag", andpad_use_flag);
        if(andpad_use_flag){
          const estimate = [invoice_natural_id];

          this.alertAndpadModal.current.toggleErrorModal(
            {
              estimate,
            }
          );

          this.setState({
            is_changed: cancel_sales_flag == true && accounts_receivable_sales == 0 ? false : quote_available_change_flag == true && is_collect_cancel == true ? true : false
          })
        }else{
          this.props.history.push("/accountsreceivable");
        }
      }
    });
  }

  all_clear(){
    const params = {
      ...this.state.data.values,
      all_clear: "true"
    }
    // console.log(this.state.data.values);

    // 全件削除
    Request.put('/api/accountsreceivable/update', params, res => {
      this.props.pageChangeAlert.current.inactivate();
      this.toggleClearModal();
      this.props.history.push("/accountsreceivable");  
    });
  }


  accounts_receivable_details({data={},index}){
    const {
      id,
      deposit_id,
      receivable_collect_date,
      receivable_collect_amt,
      receivable_collect_type,
      receivable_collect_bank_type,
      receivable_collect_memo,
      // extention_remind_send_flag
    } = data
    const { extention_remind_send_flag } = this.state.lastUpdateData;
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    const ButtonWithRole = WithRole(Button, this.props.buttons, data)

    // 以下の場合、編集・削除ボタンを非活性にする
    // 回収済みの場合
    // 20211018 #1239対応
    // ・データ登録後は「入金種別」「入金額」の変更を許容しないように修正する（コメントのみ変更可能）
    // ・削除も禁止（マイナスの履歴を作ることで修正対応を行なう）
    const updateDisalbed = (this.state.data.values.accounts_receivable_collection_flag == 1)
    const deleteDisalbed = (this.state.data.values.accounts_receivable_collection_flag == 1) || (id !== undefined)
    return (
      data.delete !== true && 
      <>
        <tr key={index}>
          <td  style={align}>{Format.format_datetime(receivable_collect_date)}</td>
          <td  style={align}>{Format.comma_delimited(receivable_collect_amt, "円")}</td>
          <td  style={align}>{FormatCode.decode("cst_receivable_collect_type", receivable_collect_type)}<br />{receivable_collect_type == "0" ? FormatCode.decode("cst_receivable_collect_bank_type", receivable_collect_bank_type): ""}</td>
          <td  style={align}>{extention_remind_send_flag == 1 ? "通知しない" : "通知する"}</td>
          <td>
            <InputText 
              name="ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_memo"
              multiline={true}
              validateCallback={(newData) => this.validateMemoCallback(index, newData)} 
              validateType='regist'
              rootData={{values : { receivable_collect_memo : receivable_collect_memo }}}
            />
          </td>
          <td>
            <ButtonWithRole 
              button_id={"BTN_H1_02_05070"}
              type="button" 
              className="btn btn-sm" 
              data-dismiss="modal" 
              aria-label="Close" 
              disabled={updateDisalbed}
              onClick={() => {this.accountsReceivableEdit(index)}}
            >
              編集
            </ButtonWithRole>
            <ButtonWithRole 
              button_id={"BTN_H1_02_05080"}
              type="button" 
              className="btn btn-sm" 
              data-dismiss="modal" 
              aria-label="Close" 
              disabled={deleteDisalbed}
              onClick={() => {this.accountsReceivableRemove(index)}}
            >
              削除
            </ButtonWithRole>
          </td>
        </tr>
      </>
    );
  }

  calcTotalAmount(){
    const cancelSalesTotal = this.state.accountsReceivableDetails.reduce((acc, detail) => {
      // コード表の情報取得
      const typeInfo = cst_receivable_collect_type.find(item => item.value == detail.receivable_collect_type)
      // 集計対象ではない場合0とする
      const amt =
      typeInfo.aggregate &&
      typeInfo.value === 5 &&
      !detail.id &&
      detail.delete !== true
        ? detail.receivable_collect_amt
        : 0;
      return acc + amt
    }, 0)
    // 新規：入金
    const collectTotal = this.state.accountsReceivableDetails.reduce((acc, detail) => {
      // コード表の情報取得
      const typeInfo = cst_receivable_collect_type.find(item => item.value == detail.receivable_collect_type)
      // 集計対象ではない場合0とする
      const amt = typeInfo.aggregate === true && typeInfo.value != 5 && !detail.id ? detail.delete !== true? detail.receivable_collect_amt : 0 : 0
      return acc + amt
    }, 0)
    // 売上：売上-売上減額
    const calcSalesTotal = this.state.data.values.before_accounts_receivable_sales - cancelSalesTotal
    // 入金：入金-入金取消
    const receiptTotal = this.state.data.values.before_receivable_collect_total_amt + collectTotal
    // 入金取消：入力時点では入力取消は発生しないので、入力取消分を計算
    const overReceipt = receiptTotal > calcSalesTotal ? calcSalesTotal  - receiptTotal: 0;
    const calcReceiptTotal = receiptTotal + overReceipt;
    // 残額（売上<入金を超えた場合は0）
    const final_receivable_uncollect_amt = calcSalesTotal > calcReceiptTotal ? calcSalesTotal - calcReceiptTotal : 0

    let accounts_receivable_status = 0;
    let accounts_receivable_status_action = 0;
    // キャンセル: 売上 – 売上取消 = 入金 – 入金取消 = 0
    if(calcSalesTotal == 0 && calcReceiptTotal == 0){
      accounts_receivable_status = 3;
      accounts_receivable_status_action = 3
      // 回収済: 売上 – 売上取消 = 入金 – 入金取消 > 0
    }else if((calcSalesTotal == calcReceiptTotal) && (calcSalesTotal > 0)){
      accounts_receivable_status = 2;
      accounts_receivable_status_action = 2
    // 未回収: 売上 – 売上取消 > 入金 – 入金取消 ≧ 0
    }else if((calcSalesTotal > calcReceiptTotal) && (calcSalesTotal + calcReceiptTotal) >= 0){
      accounts_receivable_status = 0;
      accounts_receivable_status_action = 0;
    }else{
      console.log("回収状況が条件にありません")
    }

    this.setState({
      data : {
        ...this.state.data,
        values : {
          ...this.state.data.values,
          cancel_sales: cancelSalesTotal, //売上減額
          accounts_receivable_sales: calcSalesTotal, //売上合計
          receivable_collect_total_amt : calcReceiptTotal, //入金合計
          receivable_uncollect_amt : final_receivable_uncollect_amt, //売掛金残額
          overReceipt : overReceipt, //入金取消額(未登録のデータのもの)
          accounts_receivable_status: accounts_receivable_status,
          accounts_receivable_status_action: accounts_receivable_status_action,
        }
      }
    }, () => {this.toggleDefaultAccountsReceivableStatusAction()})
  }

  toggleDefaultAccountsReceivableStatusAction() {
    return
    const allRed = this.state.accountsReceivableDetails.filter(item =>(item.delete!==true)).every(detail => detail.receivable_collect_type === 5); // すべて赤
    const accounts_receivable_status_action_radio_type1 = this.state.data.values.receivable_uncollect_amt <= 0 && allRed;
    if(accounts_receivable_status_action_radio_type1) {
      if(this.state.data.values.accounts_receivable_status_action != 3){
        const newData = {
          ...this.state.data,
          values: {
            ...this.state.data.values,
            accounts_receivable_status_action: 3,
          }
        };
        this.setState({
          data : newData
        }, () => {this.validateCallback(newData)});
      }
    } else {
      if(this.state.data.values.accounts_receivable_status_action != 1){
        const newData = {
          ...this.state.data,
          values: {
            ...this.state.data.values,
            accounts_receivable_status_action: 1,
          }
        };
        this.setState({
          data: newData
        }, () => {this.validateCallback(newData)});
      }
    }
  }

  render() {
    const AccountsReceivableDetails = this.accounts_receivable_details
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
    const user = this.state.user_list.find(user => user.id === this.state.dialogData.values.receivable_collect_user_id)
    const allRed = this.state.accountsReceivableDetails.filter(item =>(item.delete!==true)).every(detail => detail.receivable_collect_type === 5); // すべて赤
    // const accounts_receivable_status_action_radio_type1 = this.state.data.values.receivable_uncollect_amt <= 0 && allRed;
    // const accounts_receivable_status_action_disabled_option = accounts_receivable_status_action_radio_type1 ? [1,2] : [3]
    // 入金種別の項目を減らしたが、過去データには必要なため、以下の内容で出しわけ
    const receivable_collect_type = this.state.dialogData.values.receivable_collect_type
    const use_collect_receipt = !receivable_collect_type || [0,1,2,5].includes(receivable_collect_type) ? new_cst_receivable_collect_type : cst_receivable_collect_type ;
    // 一覧表示に使用する項目
    // const estimateId = this.state.data?.values?.estimate_id;
    const accountsLogData = this.state.accountsLogs ? this.state.accountsLogs || {} : {};
    const daily_closing_flag_status = accountsLogData?.logs?.filter(item=>item.daily_closing_flag==1).length > 0;

    const loan_total = accountsLogData.loan_total;
    // 条件を満たさない場合、回収済み選択不可： 売上ー売上取消 ＝ 入金ー入金取消
    const collected_disabled_option = accountsLogData && this.state.data.values.receivable_uncollect_amt == 0 && loan_total == 0 ? [] : [1];

    return (
      <>
        <div className="content">
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h3" className="float-left">{`売掛金管理　入金履歴${this.state.view?"更新":"登録"}`}</CardTitle>
              </CardHeader>
              <Col md="11"  className="detail">
                <Table>
                  <tbody>
                    <tr>
                      <th>請求金額</th>
                      <th className="sub">入金額合計</th>
                      <th className="sub">残額</th>
                    </tr>
                    <tr>
                      <td>
                        {/* {Format.comma_delimited(this.state.data.values.invoice_amt,"円")} */}
                        {Format.comma_delimited(this.state.data.values.invoice_amt,"円")}
                        {/* ({Format.comma_delimited(accountsLogData.sales,"円")}) */}
                        {/* ({Format.comma_delimited(this.state.data.values.invoice_amt - this.state.data.values.cancel_sales,"円")}) */}
                        ({Format.comma_delimited(this.state.data.values.accounts_receivable_sales,"円")})
                      </td>
                      <td>
                        {Format.comma_delimited(this.state.data.values.receivable_collect_total_amt,"円")}
                      </td>
                      <td>
                        {Format.comma_delimited(this.state.data.values.receivable_uncollect_amt,"円")}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left">請求先情報</CardTitle>
                  </Col>
                </Row>
                  <Table>
                    <tbody>
                      <tr>
                          <th>請求ID</th>
                          <th>顧客名</th>
                          <th>支払期限日</th>
                          <th>入金口座</th>
                          <th>入金メモ</th>
                      </tr>
                      <tr>
                        <td>{this.state.data.values.invoice_natural_id}</td>
                        <td>
                          {this.state.data.values.customer_name && <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', this.state.data.values)}} />}
                        </td>
                        <td>{Format.format_date(this.state.data.values.payment_deadline)}</td>
                        <td>
                          {this.state.data.values.invoice_bank_name && <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_invoice_bank', this.state.data.values)}} />}
                        </td>
                        <td>{this.state.data.values.accounts_receivable_memo}</td>
                      </tr>
                    </tbody>
                  </Table>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left sub">入金履歴</CardTitle>
                  </Col>
                  <Col md="6">
                    <ButtonWithTooltip 
                      button_id={"BTN_H1_02_05060"}
                      onclick={() => { this.toggleRegistModal(true); }} 
                      disabled={
                        this.state.data.values.accounts_receivable_collection_flag == 1
                        || this.state.accountsReceivableDetails.filter(item =>(item.delete!==true)).length >= 10}
                      class="btn-search btn-facebook float-right" 
                      id="tmp" 
                      icon="fas fa-plus"
                      label="追加" 
                      message="入金履歴を追加します。"
                    />

                    &nbsp;

                    <ButtonWithRole 
                      button_id={"BTN_H1_02_05130"}
                      type="button" 
                      className="btn-search btn-facebook float-right mr-1" 
                      data-dismiss="modal" 
                      aria-label="Close" 
                      disabled_view={false}
                      disabled={
                        this.state.accountsReceivableDetails.filter(item =>(item.delete!==true)).length == 0 ||
                        this.state.data.values.accounts_receivable_collection_flag == 1 ||
                        daily_closing_flag_status
                      }
                      onClick={() => {this.toggleClearModal(true)}}
                    >
                      入金履歴削除
                    </ButtonWithRole>
                  </Col>
                </Row>
                <Table>
                    <tbody>
                      <tr>
                        <th className="sub">入金日</th>
                        <th className="sub">入金額</th>
                        <th className="sub">入金種別</th>
                        <th className="sub">延長リマインド通知</th>
                        <th className="sub">入金履歴メモ</th>
                        <th className="sub">削除</th>
                      </tr>
                    {this.state.accountsReceivableDetails.length>0 && this.state.accountsReceivableDetails.map((data,index)=> {
                      return <AccountsReceivableDetails data={data} index={index} key={index}/>
                    })}
                    </tbody>
                </Table>
                <Container>
                  <Row>
                    <Col md="1"></Col>
                    <Col md="8">
                      <InputRadio
                        options={cst_accounts_receivable_status_action}
                        validateCallback={this.validateCallback} 
                        rootData={this.state.data}
                        labelOn={false}
                        disabled={true}
                        validateType="regist"
                        name="ACCOUNTS_RECEIVABLE__accounts_receivable_status_action"
                        />
                    </Col>
                    <Col md="3">
                      <div>
                        回収済フラグ：
                      </div>
                      <InputRadio
                        label='回収状況'
                        options={cst_accounts_receivable_collection_action}
                        disabled_options={collected_disabled_option}
                        validateCallback={this.validateCallback} 
                        rootData={this.state.data}
                        labelOn={false}
                        validateType="regist"
                        name="ACCOUNTS_RECEIVABLE__accounts_receivable_collection_flag"
                      />
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md="6" className="text-center">
                      <ButtonWithRole button_id={"BTN_H1_02_05090"} color="secondary" onClick={() => { this.props.history.push("/accountsreceivable")  }}>一覧に戻る</ButtonWithRole>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        button_id="BTN_H1_02_05100"
                        color="secondary info"
                        onClick={() => {
                          this.toggleQuoteAvailableChangeRangeModal()
                        }}
                      >
                        契約期間変更
                      </ButtonWithRole>
                      &nbsp;
                      <ButtonWithRole
                        button_id="BTN_H1_02_05100"
                        color="secondary info"
                        onClick={() => {
                          if(this.validate(this.state.data.errors)){
                            this.toggleSubRegistModal()
                          }
                        }}
                      >
                        入金登録
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Card>
          </Col>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">入金履歴登録</h5>
          </div>
          <ModalBody>
            <Row className="detail">
              <Col md="12">
                <Table>
                  <tbody>
                    <tr>
                      <CustomTd label='入金日'
                          name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date'
                          copy={false}
                          rootData={this.state.dialogData}
                          value={
                            <InputDatetime
                              validateCallback={this.validateDialogCallback} 
                              validateType='regist'
                              timeFormat={true}
                              disabled={this.state.dialogData.values.id !== undefined}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='入金額'
                          copy={false}
                          value={
                            <Row>
                              <Col md="8">
                                <InputNumber
                                  name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_amt'
                                  rootData={this.state.dialogData}
                                  validateCallback={this.validateDialogCallback} 
                                  validateType='regist'
                                  size={12}
                                  unit="円"
                                  disabled={this.state.dialogData.values.id !== undefined}
                                />
                              </Col>
                              <Col md="4">
                                <ButtonWithRole 
                                  button_id ={"BTN_H1_02_05110"}
                                  disabled={this.state.dialogData.values.id !== undefined}
                                  size="sm" 
                                  color="secondary" 
                                  onClick={() => {
                                    this.setState({
                                      dialogData : {
                                        ...this.state.dialogData,
                                        values : {
                                          ...this.state.dialogData.values,
                                          receivable_collect_amt : 
                                            this.state.accountsHistoryIndex !== undefined
                                            ? this.state.accountsReceivableDetails[this.state.accountsHistoryIndex].receivable_collect_amt + this.state.data.values.receivable_uncollect_amt
                                            : this.state.data.values.receivable_uncollect_amt
                                        },
                                        errors : {
                                          ...this.state.dialogData.errors,
                                          receivable_collect_amt : undefined
                                        }
                                      }
                                    })
                                  }}>残額全て</ButtonWithRole>
                              </Col>
                            </Row>
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='入金種別'
                        name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_type'
                        copy={false}
                        rootData={this.state.dialogData}
                        value={
                          <InputSelect
                            options={use_collect_receipt}
                            validateCallback={this.validateDialogCallback} 
                            validateType='regist'
                            isSearchable={true}
                            zIndex="99999"
                            disabled={this.state.dialogData.values.id !== undefined}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='銀行種別'
                        name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_bank_type'
                        copy={false}
                        rootData={this.state.dialogData}
                        value={
                          <InputSelect
                            options={cst_receivable_collect_bank_type}
                            validateCallback={this.validateDialogCallback} 
                            validateType='regist'
                            isSearchable={true}
                             zIndex="99999"
                            disabled={this.state.dialogData.values.receivable_collect_type !== 0 || this.state.dialogData.values.id !== undefined}
                          />
                        }
                      />
                    </tr>
                    <tr>
                    <CustomTd 
                        label='仮受金残額'
                        name='SUSPENSERECEIPTSACCOUNT__suspense_receipts_account_collect_amt'
                        copy={false}
                        value = {Format.comma_delimited(this.state.suspenseReceiptsAccountCollectAmt, "円")}
                      />
                    </tr>
                    <tr>
                      <td class="subTitle">
                        延長リマインド通知 
                      </td>
                      <td>
                        <InputCheckBox
                            label='通知しない'
                            labelOn={false}
                            name="ESTIMATE__extention_remind_send_flag" 
                            validateCallback={this.validateDialogCallback} 
                            checkedValue={1}
                            uncheckedValue={0}
                            // 2026/01/06 #2423
                            // disabled={this.state.dialogData.values.receivable_collect_type != 5}
                            rootData={this.state.dialogData}
                            />

                      </td>
                    </tr>

                    <tr>
                      <CustomTd label='入金履歴メモ'
                        name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_memo'
                        copy={false}
                        rootData={this.state.dialogData}
                        value={
                          <InputText multiline={true}
                            validateCallback={this.validateDialogCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label='入金履歴登録者'
                        name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_user_id'
                        copy={false}
                        value = {user ? user.name : ""}
                      />
                    </tr>
                  </tbody>
                </Table>
            </Col>
            <Col md="12" className="text-center">
              <ButtonWithRole 
                button_id = {"BTN_H1_02_05120"}
                color="info" 
                onClick={() => {
                  this.selectedSecurityDeposit();
                }} className="float-right"
              >
                入金履歴追加
              </ButtonWithRole>
            </Col>
          </Row>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.sub_regist_modal} toggle={this.toggleSubRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleSubRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">入金登録</h5>
          </div>
          <ModalBody>
            <p>入金登録をします。よろしいですか？</p>
            {(this.state.data.values.accounts_receivable_status === 2 || this.state.data.values.accounts_receivable_status === 3)
            && this.state.data.values.receivable_uncollect_amt !== 0 &&
            <div style={{color:"red"}}>{GetMessage(2464)}</div>}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubRegistModal}>
              いいえ
            </Button>
            <Button color="info" onClick={()=>{this.regist()}}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.quote_available_change_range_modal} toggle={this.toggleQuoteAvailableChangeRangeModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleQuoteAvailableChangeRangeModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">契約期間変更</h5>
          </div>
          <ModalBody>
            確定見積書契約期間:
            <Row>
              <Col md="5">
              契約開始日 {Format.format_date_yyyymmdd(this.state.data.values.quote_available_start_date)}
              </Col>
              <Col md="5">
              契約終了日 {Format.format_date_yyyymmdd(this.state.data.values.quote_available_end_date)}
              </Col>
              <Col md="2">
              台数 {this.state.data.values.quote_capacity_qty}
              </Col>
            </Row>
            確定見積書確定後変更日:
            <Row>
              <Col md="4">
              変更後開始日<br/>
              <InputDatetime
                label=''
                name='ESTIMATE__quote_available_change_start_date'
                validateCallback={this.validateQuoteAvailableChangeDate} // 範囲チェックなしの値設定のみ
                validateType='regist'
                rootData={this.state.dialogData}
                timeFormat={false}
                disabled={false}
              />
              </Col>
              <Col md="4">
              変更後終了日<br/>
              <InputDatetime
                label=''
                name='ESTIMATE__quote_available_change_end_date'
                validateCallback={this.validateQuoteAvailableChangeDate}  // 範囲チェックなしの値設定のみ
                validateType='regist'
                rootData={this.state.dialogData}
                timeFormat={false}
                disabled={false}
              />
              </Col>
            </Row>
            <Row>
            {this.state.dialogData.errors.quote_available_change_range_failure !== undefined &&
            <div style={{color:"red"}}>{this.state.dialogData.errors.quote_available_change_range_failure}</div>}
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleQuoteAvailableChangeRangeModal}>
              キャンセル
            </Button>
            <Button color="info" onClick={()=>{
              this.validateQuoteAvailableChangeDate(this.state.dialogData, ()=>{
                // console.log(this.state.dialogData)
                // console.log(this.state.dialogData.errors)
                // console.log(this.state.dialogData.errors.quote_available_change_range_failure !== undefined)

                if(this.state.dialogData.errors.quote_available_change_range_failure === undefined) {
                  // 登録・更新API呼び出し
                  const url = '/api/estimate/quote_available_change/'+ this.state.data.values.estimate_ulid
                  const params = {
                    quote_available_change_start_date: this.state.dialogData.values.quote_available_change_start_date,
                    quote_available_change_end_date: this.state.dialogData.values.quote_available_change_end_date,
                    update_timestamp: this.state.data.values.estimate_update_timestamp,
                  };
                  Request.patch(url, params, (res)=>{
                    // 更新した値でthis.state.dataを更新
                    // 編集中の入金履歴が消えないように、画面再読み込みはしない
                    this.setState({
                      data : { 
                        ...this.state.data,
                        values : {
                          ...this.state.data.values,
                          quote_available_change_start_date: this.state.dialogData.values.quote_available_change_start_date,
                          quote_available_change_end_date: this.state.dialogData.values.quote_available_change_end_date,
                          estimate_update_timestamp: res.data.update_timestamp,
                        }
                      }
                    }, () => {
                      this.toggleQuoteAvailableChangeRangeModal();
                    })
                  })
                }
              }, true);

            }}>
              更新
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.clear_modal} toggle={this.toggleClearModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleClearModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">履歴削除</h5>
          </div>
          <ModalBody>
            <p>入金履歴をクリアします。<br />
              以下の情報はクリアされますがよろしいですか？<br />
              ・登録されている入金履歴データ<br />
              ・登録前の入金履歴データ（画面表示分）<br />
              {/* 2026/01/08 不具合一覧2495 */}
              {/* ・延長リマインド通知設定 */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleClearModal}>
              キャンセル
            </Button>
            <Button color="info" onClick={()=>{this.all_clear()}}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
        <AlertAndpadModal
          ref={this.alertAndpadModal} 
          returnCallback={() => {
            this.props.history.push("/accountsreceivable");
          }}
          is_change={this.state.is_changed}
        />
      </>
    );
  }
}

export default Regist;
